import React from "react"

export default function StatusTag({status}) {    
    return (
        <div>
            <p className={"status-tag " + status }>{status}</p>
        </div>
        
    )
}
